export class ILogicalAudit {
    AdminId: string;
    providerId: string;
    FromDate: Date;
    ToDate: Date;
    createdBy: string;
    modifiedBy: string;
    createdOn: Date;
    modifiedOn: Date;
    isActive: boolean;
    grantAccess: boolean;
    msgType: string;
    createddate: string;
    facilityId: number;
    locationId: number;
}


